import { zip } from "./zip";

export function pairWise<T>(list: T[]): Array<[T, T]> {
  return zip(list, list.slice(1));
}
